// extracted by mini-css-extract-plugin
export default {"title":"JKUAGgmRUbeiVctIj_GI"};